import { apiSlice } from "core/api";
import { makeCrudEndpoints } from "common/api/apiHelpers";
import { HtmlPage } from "htmlpage/types/html-page.model";

const api = apiSlice.injectEndpoints({
  endpoints: makeCrudEndpoints<"HTMLPage", HtmlPage>("HTMLPage", "html-pages"),
});

export const {
  useGetHTMLPageQuery,
  useListHTMLPagesQuery,
  useAddHTMLPageMutation,
  useRemoveHTMLPageMutation,
  useUpdateHTMLPageMutation,
} = api;
